export class UserCreationDto {
  constructor(dto) {
    this.first_name = dto.first_name;
    this.middle_name = dto.middle_name;
    this.last_name = dto.last_name;
    this.job_title = dto.job_title;
    this.group_id = dto.group_id;
    this.email = dto.email;
    this.phone_number = dto.phone_number;
    this.additional_phone_number = dto.additional_phone_number;
    this.street = dto.street;
    this.street2 = dto.street2;
    this.city = dto.city;
    this.state = dto.state_code;
    this.zip_code = dto.zip_code;
    this.dob = dto.dob;
    this.username = dto.username;
    this.language_id = dto.language_id;
    this.rbs_server_id = dto.rbs_server_id;
    this.company_name = dto.company_name;
  }
}

export class UsersUpdateDto {
  constructor(data) {
    this.user_id = data.user_id;
    this.dob = data.dob;
  }
}

export class UserCreationExtendDto {
  constructor(data) {
    this.username = data.username;
    this.password = data.password;
    this.password_confirmation = data.password_confirmation;
    this.first_name = data.first_name;
    this.middle_name = data.middle_name;
    this.last_name = data.last_name;
    this.job_title = data.job_title;
    this.email = data.email;
    this.email_confirmation = data.email_confirmation;
    this.dob = data.dob;
    this.group_name = data.group_name;
    this.phone_number = data.phone_number;
    this.street = data.street;
    this.city = data.city;
    this.state = data.state;
    this.zip_code = data.zip_code;
    this.employee_id = data.employee_id;
    this.store_number = data.store_number;
    this.corporate_code = data.corporate_code;
  }
}
